import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { DropDownListDTO } from './../../../entity/dto/dropdownlist.component';
import * as moment from 'moment';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-qua042-card-I',
    templateUrl: './qua042-card-I.component.html'
})

export class Qua042CardIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listCentro?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public filteredCentroOptions: Observable<DropDownListDTO[]>;
    public listCentroOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listProcesso?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public filteredProcessoOptions: Observable<DropDownListDTO[]>;
    public listProcessoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTipoEnsaque?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public filteredTipoEnsaqueOptions: Observable<DropDownListDTO[]>;
    public listTipoEnsaqueOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listCSouTB?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public filteredCSouTBOptions: Observable<DropDownListDTO[]>;
    public listCSouTBOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhaReprocessamentoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhaReprocessamento?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTurnoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTurno?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPeneira?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPeneiraOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPeneiraBasic?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPeneiraOriginalBasic?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLoteOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhaEnsaque?: DropDownListDTO[] = [];
    public listTamanhoSacaria?: DropDownListDTO[] = [];
    public listSafra?: DropDownListDTO[];
    public listSafraOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLoteSaida: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public disableNumeroCampo: boolean = false;
    public safraBasicaOld = ''

    regexContrato = /^[a-zA-Z]{3}-[a-zA-Z]\d{4}$|^[a-zA-Z]\d[a-zA-Z]\d{4}$|^[A-Za-z]{3}-[VvIi]\d{4}\d?$|^[A-Za-z]{3}-[VvIi]\d{4}\d?[;]?$|^[a-zA-Z]\d[a-zA-Z]\d{5}$/;


    @Output() objPc003 = new EventEmitter();
    @Output() pc003DataFromFieldNumber = new EventEmitter<{ safra: string, numeroCampo: string }>();
    @Output() objEt004 = new EventEmitter();
    //@Output() objHumidity = new EventEmitter();
    @Output() mkCalc = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
        super('Informações de Lote', false);
        if (this.isComercial) {
            this.formulario = this.formBuilder.group({
                centro_ensaque: [null, [Validators.required]],
                contrato_juridico: [null, [Validators.pattern(this.regexContrato)]],
                lote_origem: [null, [Validators.required, Validators.pattern(this.regexLoteCs)]],
                processo_origem: [null, [Validators.required]],
                centro_campo: [null, []],
                centro_producao: [null, [Validators.required]],
                ordem_processo: [null, []],
                especie: [null, []],
                hibrido_rnc: [null, []],
                lote_saida: [null, [Validators.required]],
                codigo_material: [null, [Validators.required]],
                peneira: [null, []],
                grupo_peneira: [null, []],
                validade: [null, [Validators.pattern('\^[A-z]{3}[/20][0-9]{4}')]],
                safra: [null, []], /*[Validators.pattern('\^[A-z]{2}[0-9]{2}')]*/
                safra_boletim: [null, [Validators.pattern('\^[20]{2}[0-9]{2}[\/][{1}[20]{2}[0-9]{2}')]],
                // total_sacos: [null, []],
                tipo_ensaque: [null, [Validators.required]],
                silo_classificado_ou_big_bag: [null, []],
            });
        } else if (this.isBasica) {
            this.formulario = this.formBuilder.group({
                centro_ensaque: [null, []],
                numero_campo: [null, []],
                contrato_juridico: [null, []],
                lote_origem: [null, []],
                centro_campo: [null, []],
                ordem_processo: [null, []],
                especie: [null, []],
                geracao: [null, []],
                hibrido_rnc: [null, []],
                lote_saida: [null, []],
                codigo_material: [null, []],
                peneira: [null, []],
                safra: [null, []],
            });
        }
        else if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                centro_ensaque: [null, [Validators.required]],
                numero_campo: [null, [Validators.required]],
                contrato_juridico: [null, [Validators.required]],
                lote_origem: [null, []],
                centro_campo: [null, []],
                ordem_processo: [null, []],
                especie: ['MILHO', [Validators.required]],
                geracao: [null, [Validators.required]],
                hibrido_rnc: [null, [Validators.required]],
                lote_saida: [null, [Validators.required]],
                codigo_material: [null, []],
                peneira: [null, []],
                safra: [null, [Validators.required]],
                safra_basica: [null, [Validators.required]],
                status_lote: ['Aprovado', []],
                peso_pa: [null, [Validators.max(20), Validators.min(0), Validators.required]],
                num_sementes_saco: ['', []],
                total_sacos: [null, [Validators.required]],
                peso_total_lote_kg: [null, [Validators.required]],
                peso_mil_sementes: [null, [Validators.required]],
                data_ensaque: ['', [Validators.required]],
                linha_ensaque: [null, [Validators.required]],
                tamanho_da_sacaria: [null, [Validators.required]],
                codigo_embalagem: [null, []],
                perdas_embalagens_erro_impressao: [null, []],
                perdas_embalagens_erro_costura: [null, []],
                perdas_embalagens_outras_ocorrencias: [null, []],
                qntd_embalagem_canguru: [null, []],
                total_perdas_embalagens: [null, []],
                quantidade_embalagens_un: [null, []],
                descarte_tratado_kg: ['', []]


            });
        }
    }

    async ngOnInit(): Promise<void> {
        this.formulario?.get('centro_ensaque').setValue(this.generalService.getCentroEnsaqueByLocalStorageDataSite());
        await Promise.all([this.getLists()]);
    }

    async getLists(): Promise<void> {
        await Promise.all([this.getListCentro(), this.getListPeneira(), this.getPeneiraBasicDropdownOptions(), this.getListProcesso(), this.getListTipoEnsaque(), this.getListSafra(), this.centroCampoBasica(), this.getLinhaEnsaque(), this.getListTamanhoSacaria()]);
    }


    async getListSafra(): Promise<void> {
        await this.formularioService
            .getListDropDownList('qua007', 'safra')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listSafra = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    this.listSafraOriginal = this.listSafra;
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorSafra
                );
            });
    }
    async getListLote(): Promise<void> {
        if (this.formulario?.get('safra').value && this.formulario?.get('numero_campo').value) {
            this.formularioService.getListDropDownLoteSaida(this.formulario?.get('safra').value, this.formulario?.get('numero_campo').value)
                .pipe(take(1))
                .toPromise()
                .then((response) => {
                    if (!!response?.data) {
                        this.listLoteSaida = response.data
                    }
                })
                .catch(async (error: HttpErrorResponse) => {
                    this.notificationService.showNotificationError(
                        error,
                        '',
                        TypeMessage.ListErrorHibrido
                    );
                });
        }
    }

    async getListPeneira(): Promise<void> {
        await this.formularioService
          .getListDropDownList('qua042', 'peneira')
          .pipe(take(1))
          .toPromise()
          .then((response) => {
            if (!!response?.data) {
              this.listPeneira = this.generalService.orderByDropDownList(
                response.data as DropDownListDTO[]
              );
              this.listPeneiraOriginal = this.listPeneira;
            }
          })
          .catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(
              error,
              '',
              TypeMessage.ListErrorPeneira
            );
          });
      }

    async createFilterSafra(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (
                this.listSafraOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                ).length > 0
            ) {
                this.listSafra = this.listSafraOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                );
            } else {
                this.listSafra = this.listSafraOriginal;
            }
        } else {
            this.listSafra = this.listSafraOriginal;
        }
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getDataPc003(): Promise<void> {
        this.objPc003.emit();
    }

    async getDataEt004(): Promise<void> {
        this.objEt004.emit();
    }

    // async isOnline() {
    //     await this.generalService.getConnectionStatus().subscribe(async status => {
    //         if (status) {
    //             return true;
    //         } else {
    //             return false;
    //         }
    //     }).unsubscribe();
    // }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    createFilterCentro(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listCentroOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listCentro = this.listCentroOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listCentro = this.listCentroOriginal;
            }
        } else {
            this.listCentro = this.listCentroOriginal;
        }
    }

    async getListCentro(): Promise<void> {
        await this.formularioService.getListDropDownList('qua042', 'centro_ensaque').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listCentro = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listCentroOriginal = this.listCentro;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    createFilterProcesso(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listProcessoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listProcesso = this.listProcessoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listProcesso = this.listProcessoOriginal;
            }
        } else {
            this.listProcesso = this.listProcessoOriginal;
        }
    }

    async getListProcesso(): Promise<void> {
        await this.formularioService.getListDropDownList('qua042', 'processo_origem').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listProcesso = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listProcessoOriginal = this.listProcesso;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async lotesSaidaQua042Exists() {
        const lote_saida: string = this.formulario.get('lote_saida')?.value
        const response = await this.formularioService.validateLotesSaidaQua042(lote_saida)
        if (response.error) {
            this.formulario.get('lote_saida')?.setErrors({ duplicatedLoteSaida: true })
        }
    }

    createFilterTipoEnsaque(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listTipoEnsaqueOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTipoEnsaque = this.listTipoEnsaqueOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTipoEnsaque = this.listTipoEnsaqueOriginal;
            }
        } else {
            this.listTipoEnsaque = this.listTipoEnsaqueOriginal;
        }
    }

    async getListTipoEnsaque(): Promise<void> {
        await this.formularioService.getListDropDownList('qua042', 'tipo_ensaque').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listTipoEnsaque = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listTipoEnsaqueOriginal = this.listTipoEnsaque;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async getListTurno(): Promise<void> {
        //   await this.formularioService.getListDropDownList('cd001_repasse', 'turno').pipe(take(1)).toPromise().then(response => {
        //       if (!!response?.data) {
        //           this.listTurno = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        //           this.listTurnoOriginal = this.listTurno;
        //       }
        //   }).catch(async (error: HttpErrorResponse) => {
        //       this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurno);
        //   });
    }

    async createFilterLinhaReprocessamento(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listLinhaReprocessamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal;
            }
        } else {
            this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal;
        }
    }

    async createFilterTurno(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listTurnoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTurno = this.listTurnoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTurno = this.listTurnoOriginal;
            }
        } else {
            this.listTurno = this.listTurnoOriginal;
        }
    }

    getPC003DataEmit(): void {
        const numeroCampo: string = this.formulario.controls.numero_campo.value
        const safra: string = this.formulario.get('safra').value
        console.log(numeroCampo, safra)
        if (numeroCampo != '' && numeroCampo != null && safra != '' && safra != null) {
            this.pc003DataFromFieldNumber.emit({ safra, numeroCampo });
            this.formulario.controls.lote_origem.reset();
            this.getLoteOrigemDropdownOptions(safra, numeroCampo);
        }
    }

    centroCampoBasica() {
        const site = localStorage.getItem('data_site');
        const areaSelected = this.areaSelect;

        if (this.isBasica) {
            if (site === 'CDR') {
                this.formulario.get('centro_campo').setValue(1160);
            } else if (site === 'PTU-BÁSICA') {
                this.formulario.get('centro_campo').setValue(1040);
            }
        }
    }

    getPeneiraBasicDropdownOptions(): void {
        this.formularioService
            .getListDropDownList('cd001_classificacao', 'peneira_basica')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listPeneiraBasic = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    this.listPeneiraOriginalBasic = this.listPeneiraBasic
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorPeneira
                );
            });
    }


    private async getLoteOrigemDropdownOptions(safra: string, numero_campo: string): Promise<any> {
        try {
            var response = await this.formularioService.getListDropDownLoteDS(safra, numero_campo).pipe(take(1)).toPromise();
            this.listLoteOrigem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        } catch (error) {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorPeneira);
        }
    }

    createFilterPeneira(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listPeneiraOriginal.filter((x) => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPeneira = this.listPeneiraOriginal.filter((x) => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPeneira = this.listPeneiraOriginal;
            }
        } else {
            this.listPeneira = this.listPeneiraOriginal;
        }
    }

    createFilterPeneiraBasic(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listPeneiraOriginalBasic.filter((x) => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPeneiraBasic = this.listPeneiraOriginalBasic.filter((x) => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPeneiraBasic = this.listPeneiraOriginalBasic;
            }
        } else {
            this.listPeneiraBasic = this.listPeneiraOriginalBasic;
        }
    }

    makeCalc() {
        if (this.formulario?.get('safra_basica').value.length >= 4) {
            const safraBasica = this.formulario?.get('safra_basica').value
            this.formulario?.get('safra').setValue(safraBasica.slice(0, 2) + safraBasica.slice(3));
            if (safraBasica != "" || safraBasica != null) {

                this.disableNumeroCampo = this.safraBasicaOld == safraBasica
            }
            this.checkNumeroCampo();
        }
    }
    getDataFromQua007($event) {
        if (this.formulario?.get('safra').value &&
            this.formulario?.get('numero_campo').value) {
            this.formularioService.getQua007Contrato({ safra: this.formulario?.get('safra').value, numero_campo: this.formulario?.get('numero_campo').value }).pipe(take(1))
                .toPromise()
                .then((response) => {
                    this.formulario?.get('contrato_juridico').setValue(response.data.contrato_juridico);
                    this.formulario?.get('hibrido_rnc').setValue(response.data.hibrido_rnc);
                    this.formulario?.get('geracao').setValue(response.data.geracao);
                });
            this.getListLote();
        }

    }

    calcPesoTotal($event) {
        if (this.formulario?.get('total_sacos').value && this.formulario.get('peso_pa').value)
            this.formulario?.get('peso_total_lote_kg').setValue(Number(this.formulario?.get('total_sacos').value) * Number(this.formulario.get('peso_pa').value));
        this.calcPerdas(null);
    }

    calcDatesEvent($event) {
        if (moment(this.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY") > moment())
            this.formulario?.controls['data_ensaque'].setErrors({ 'dateHighThanActual': true });
        else if (moment(this.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY") <= moment())
            this.formulario?.controls['data_ensaque'].setErrors(null);
    }


    async getLinhaEnsaque(): Promise<void> {
        const site: string = this.generalService.getLocalStorageDataSite();
        await this.formularioService
            .getListDropDownList('qua042', 'linha_ensaque', site)
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listLinhaEnsaque = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    )
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorSafra
                );
            });
    }

    async getListTamanhoSacaria(): Promise<void> {
        const site: string = this.generalService.getLocalStorageDataSite();
        await this.formularioService
            .getListDropDownList('qua042', 'tamanho_da_sacaria', site)
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listTamanhoSacaria = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    )
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorSafra
                );
            });
    }

    calcPerdas($event) {
        this.formulario?.get('total_perdas_embalagens').setValue(
            Number(this.formulario?.get('perdas_embalagens_erro_impressao').value) +
            Number(this.formulario?.get('perdas_embalagens_erro_costura').value) +
            Number(this.formulario?.get('perdas_embalagens_outras_ocorrencias').value))

        if (this.formulario?.get('total_sacos').value) {
            this.formulario?.get('quantidade_embalagens_un').setValue(Number(this.formulario?.get('total_perdas_embalagens').value) + Number(this.formulario?.get('total_sacos').value));
        }


    }

    async checkNumeroCampo() {
        const site = this.formulario.get('centro_ensaque')?.value
        const safra = this.formulario.get('safra_basica')?.value
        const numeroCampo = this.formulario.get('numero_campo')?.value
        if (!site || !safra || !numeroCampo || this.disableNumeroCampo) {
            return
        }
        this.formularioService.checkNumeroCampo('qua042', {
            filters: {
                numero_campo: String(numeroCampo) as string,
                centro_ensaque: site as string,
                safra_basica: safra as string
            }
        }).pipe(take(1)).toPromise().then((response: any) => {

            if ((response.data as boolean) === true) {
                this.formulario.get('numero_campo').setErrors({ invalidExist: true });;
                this.notificationService.sendNotification(`O Numero do campo ${numeroCampo} já está cadastrado na base de dados, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
            } else {
                this.formulario.get('numero_campo').setErrors({ invalidExist: false });
                this.formulario.get('numero_campo').updateValueAndValidity();
                this.getDataFromQua007(null);
            }

        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

}
